module.exports = __webpack_public_path__ + "static/assets/6597f0ef5738e2f515586f4bf26d92d7.svg";